import Immutable from "immutable";
import { requestAsync } from "lib/api";
import { fetchQuery } from "queries/filters";
import { formatMessage } from "lib/globalize-util";
import { FILTERS_FAILURE, FILTERS_REQUEST, FILTERS_SUCCESS, FILTERS_CACHE_UPDATE } from "constants/action-types";

export const fetchFilters = ({ brandId, resource }) => {
    return (dispatch, getState) => {
        dispatch({
            type: FILTERS_REQUEST,
        });

        dispatch(requestAsync(fetchQuery({ brandId, resource }))).then(({ status, transformed, body }) => {
            if (status >= 200 && status < 300) {
                dispatch({
                    result: transformed && transformed._result ? transformed._result : [],
                    type: FILTERS_SUCCESS,
                });
            } else {
                dispatch({
                    error:
                        body && body.message
                            ? new Error(body.message)
                            : formatMessage("Oops! Something went wrong. Please refresh and try again."),
                    result: [],
                    type: FILTERS_FAILURE,
                });
            }
        });
    };
};

export const updateFiltersCache = (brandId: string, key: "order", filters: Immutable.Map<string, any>) => ({
    type: FILTERS_CACHE_UPDATE,
    payload: {
        [brandId]: {
            [key]: filters,
        },
    },
});
